import React from 'react';
import { authRoles } from 'app/auth';

export const RecoverPasswordPageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/recoverPassword/:token',
			component: React.lazy(() => import('./RecoverPassword'))
		}
	]
};
